var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5998 15.3C5.6998 15.45 4.4998 14.85 4.0498 14.7L3.2998 16.05C3.2998 16.05 4.6498 16.65 5.8498 16.8V18H7.3498V16.65C8.6998 16.2 9.4498 15 9.5998 13.95C9.5998 12.75 8.6998 11.85 6.7498 11.1C6.1498 10.8 5.0998 10.35 5.0998 9.75C5.0998 9 5.6998 8.55 6.5998 8.55C7.6498 8.55 8.6998 9 8.6998 9L9.2998 7.65C9.2998 7.65 8.5498 7.35 7.4998 7.05V6H5.9998V7.05C4.6498 7.35 3.7498 8.25 3.5998 9.6C3.5998 11.4 5.5498 12.15 6.2998 12.45C7.1998 12.75 8.2498 13.35 8.2498 13.8C8.2498 14.4 7.6498 15.15 6.5998 15.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3V21H24V3H0ZM22.5 19.5H1.5V4.5H22.5V19.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H21V9H12V7.5ZM12 10.5H21V12H12V10.5ZM12 13.5H16.5V15H12V13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.31f47276fa97caa4b242eb4dbfa13262.svg";
export { ForwardRef as ReactComponent };